const translations = {
  en: {
    home: "Home",
    homeTagLine: "Full-Stack Developer | Turning Ideas into Reality",
    homeMoreBtn: "More About Me",
    about: "About",
    aboutMe: "About Me",
    aboutText1: "I'm a software engineer at IBM, working on the ",
    aboutText2: "Quantum Safe",
    aboutText3:
      " Migration Orchestrator (QSMO).\nBefore that I was a full-stack developer and software tester for ",
    aboutText4: "the French Army",
    aboutText5:
      " in Paris, then spent a long break sailing through Europe. I came back to programming through two Certificates of Advanced Studies, in Full-Stack Development and in Object-Oriented Programming.\nI like responsive, dynamic interfaces and applications that feel obvious to use.",
    aboutTextContact: "Contact me to discuss work opportunity.",
    myWork: "My Work",
    myWorkBtn: "Let's see it!",
    myWorkNoProjects: "No projects match this filter.",
    aboutMePhotoAlt: "Portrait of Rémy Santoriello",
    contact: "Contact",
    contactMe: "Contact Me",
    contactText: "Have a question or want to work together?",
    contactName: "Name",
    contactEmail: "Enter Email",
    contactMsg: "Your Message",
    contactBtn: "Submit",
  },
  fr: {
    home: "Accueil",
    homeTagLine: "Full-Stack Developer | Turning Ideas into Reality",
    homeMoreBtn: "En Savoir Plus",
    about: "A propos",
    aboutMe: "A propos",
    aboutText1: "Je suis ingénieur logiciel chez IBM, où je travaille sur le ",
    aboutText2: "Quantum Safe",
    aboutText3:
      " Migration Orchestrator (QSMO).\nAuparavant, j'étais développeur full-stack et testeur de logiciels pour ",
    aboutText4: "l'Armée française",
    aboutText5:
      " à Paris, puis j'ai fait une longue pause à naviguer à travers l'Europe. Je suis revenu à la programmation par deux Certificates of Advanced Studies, en développement full-stack et en programmation orientée objet.\nJ'aime les interfaces réactives et dynamiques, et les applications dont l'usage coule de source.",
    aboutTextContact: "Contactez-moi pour discuter d'opportunités de travail.",
    myWork: "Projets",
    myWorkBtn: "Voyons ça!",
    myWorkNoProjects: "Aucun projet ne correspond à ce filtre.",
    aboutMePhotoAlt: "Portrait de Rémy Santoriello",
    contact: "Contact",
    contactMe: "Me Contacter",
    contactText:
      "Avez-vous une question ou souhaitez-vous travailler ensemble ?",
    contactName: "Nom",
    contactEmail: "Adresse Email",
    contactMsg: "Votre Message",
    contactBtn: "Envoyer",
  },
  de: {
    home: "Start",
    homeTagLine: "Full-Stack Developer | Turning Ideas into Reality",
    homeMoreBtn: "Mehr Über Mich",
    about: "Über",
    aboutMe: "Über mich",
    aboutText1: "Ich bin Software Engineer bei IBM und arbeite am ",
    aboutText2: "Quantum Safe",
    aboutText3:
      " Migration Orchestrator (QSMO).\nZuvor war ich Full-Stack-Entwickler und Software-Tester für ",
    aboutText4: "die französische Armee",
    aboutText5:
      " in Paris, danach segelte ich eine lange Zeit durch Europa. Zur Programmierung zurückgekehrt bin ich über zwei Certificates of Advanced Studies in Full-Stack-Entwicklung und objektorientierter Programmierung.\nIch mag responsive, dynamische Benutzeroberflächen und Anwendungen, die sich von selbst erklären.",
    aboutTextContact:
      "Kontaktieren Sie mich, um über Arbeitsmöglichkeiten zu sprechen.",
    myWork: "Projekte",
    myWorkBtn: "Lass es uns sehen!",
    myWorkNoProjects: "Kein Projekt entspricht diesem Filter.",
    aboutMePhotoAlt: "Porträt von Rémy Santoriello",
    contact: "Kontakt",
    contactMe: "Kontaktiere Mich",
    contactText: "Haben Sie eine Frage oder möchten Sie zusammenarbeiten?",
    contactName: "Name",
    contactEmail: "E-Mail eingeben",
    contactMsg: "Ihre Nachricht",
    contactBtn: "Absenden",
  },
};

export default translations;
